import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";
import Link from "next/link";
import styles from "./study_specialization.module.scss";
import { useRouter } from "next/router";

export const StudySpecialization = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { query } = useRouter();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(`/public/specialization`);
        setLoading(false);
        setData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, []);

  const LoadingComponent = () => (
    <>
      <Grid container spacing={2} alignItems={"center"}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((_, i) => {
          return (
            <Grid item xs={12} sm={12} md={4} lg={3} key={i}>
              <Skeleton
                variant="circular"
                width={80}
                height={80}
                sx={{ margin: "15px auto" }}
              />
              <Skeleton variant="rectangular" width="100%" height={30} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );

  return (
    <Fragment>
      {data?.length > 0 ? (
        <section className={styles.section_specialization}>
          <div className="container">
            {loading ? (
              <LoadingComponent />
            ) : (
              <div className={styles.specialization_wrapper}>
                <ul>
                  {data?.map((sp, i) => {
                    return (
                      <Fragment key={sp?.specializationId}>
                        <Link
                          legacyBehavior
                          href={`/search?ref=course&sp=${sp?.slug}&co=${query.country_name}&limit=10&page=1`}
                        >
                          <a>
                            <li className={styles.wrapper}>
                              <div className={styles.icon_wrapper}>
                                {sp?.icon !== null && (
                                  <div className={styles.icon_image_wrapper}>
                                    <img
                                      src={sp?.icon?.src}
                                      alt={sp?.icon?.alt || "Alt text"}
                                    />
                                  </div>
                                )}
                              </div>
                              <div
                                title={sp?.specializationName}
                                className={styles.specialization_name}
                              >
                                <div>{sp?.specializationName}</div>
                              </div>
                            </li>
                          </a>
                        </Link>
                      </Fragment>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default StudySpecialization;
